// extracted by mini-css-extract-plugin
export default {"container":"errorpage_container__2a2z3"};